import { isUrl } from '@albacross/frontend-utils'

export const nameToDomainValidator = values => {
  const mappings = values.mappings?.map(mapping => {
    const error: Record<string, any> = {}

    if (!mapping.name?.alias) error.name = 'Name is required'
    if (!mapping.name?.verified) error.name = 'Name needs to be verified'

    if (!isUrl(mapping.domain)) error.domain = 'Domain is invalid'
    if (!mapping.domain) error.domain = 'Domain is required'

    return error
  })

  return { mappings }
}
